import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-700/30 py-6" style={{
      background: 'rgba(31, 41, 55, 0.4)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)'
    }}>
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center shadow-lg shadow-gray-900/30 border border-gray-600/30">
                <img src="/images/wshido.png" alt="Shido Gateway" className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Shido Gateway</h3>
                <p className="text-xs text-gray-400">Cross-chain bridge</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Secure and efficient cross-chain token transfers between Shido and other blockchains.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-white mb-3">Quick Links</h4>
            <div className="space-y-2">
              <a 
                href="https://shidoscan.net" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-sm text-gray-400 hover:text-primary-400 transition-colors"
              >
                Shidoscan
              </a>
              <a 
                href="https://app.shido.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-sm text-gray-400 hover:text-primary-400 transition-colors"
              >
                Shido DEX
              </a>
              <a 
                href="https://shido.io/terms" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-sm text-gray-400 hover:text-primary-400 transition-colors"
              >
                Terms of Service
              </a>
              <a 
                href="https://shido.io/privacy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-sm text-gray-400 hover:text-primary-400 transition-colors"
              >
                Privacy Policy
              </a>
            </div>
          </div>

          {/* Community & Social */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-white mb-3">Community</h4>
            <div className="flex space-x-4">
              <a 
                href="https://github.com/ShidoGlobal" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-700/30 hover:bg-gray-600/40 text-gray-400 hover:text-primary-400 transition-all duration-200 backdrop-blur-sm"
                title="GitHub"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://x.com/ShidoGlobal" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-700/30 hover:bg-gray-600/40 text-gray-400 hover:text-primary-400 transition-all duration-200 backdrop-blur-sm"
                title="X (formerly Twitter)"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
            <div className="mt-4">
              <p className="text-xs text-gray-500 mb-1">Built on top of</p>
              <p className="text-sm text-gray-400 font-medium">XPort Message Bridge v2</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-gray-700/30">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-2 md:mb-0">
              © {new Date().getFullYear()} Shido Gateway. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <span>Secure • Fast • Reliable</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
